import { render } from "./i-instrucoes.vue?vue&type=template&id=1697ad15&scoped=true"
import script from "./i-instrucoes.vue?vue&type=script&lang=js"
export * from "./i-instrucoes.vue?vue&type=script&lang=js"

import "./i-instrucoes.vue?vue&type=style&index=0&id=1697ad15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1697ad15"]])

export default __exports__